import type { StrapiArrayResponse } from '@/types/common/api'
import strapi from '@/utils/axios/strapi'

export const landingPathApi = {
  getHomeButtonLandingPath: async () => {
    return (
      await strapi.get<StrapiArrayResponse<res.HcmsControlLandingPath>>('/mathflat-home-buttons', {
        params: {
          populate: {
            homeButtonLinkMathflat: {
              populate: '*',
            },
            homeButtonLinkSchoolflat: {
              populate: '*',
            },
          },
        },
      })
    ).data
  },
}
